import congrats from "./congrats.png";
import get from "./get.png";
import heartActive from "./heart-active.png";
import heart from "./heart.png";
import lineActive from "./line-active.png";
import line from "./line.png";
import pointsActive from "./points-active.png";
import points from "./points.png";
import emphasizeBadge from "./emphasizeBadge.png"
import noSelectStamp from "./no-select-stamp.png";
import more from "./more.png";

export default {
    get, heart, heartActive, line, lineActive, points, pointsActive, congrats, noSelectStamp, emphasizeBadge, more,
};

